import moment from "moment";

import * as i18nUtils from "util/i18n";

export const TODAY = "TODAY";
export const ONCE = "FUTURE";
export const DAY = "DAY";
export const WEEK = "WEEK";
export const MONTH = "MONTH";
export const YEAR = "YEAR";
export const CUSTOM = "CUSTOM";
export const NEVER = "UNLIMITED";
export const UP_TO = "UP_TO";
export const UNTIL = "UNTIL";

const FIRST = "first";
const SECOND = "second";
const THRID = "third";
const FOURTH = "fourth";
const LAST = "last";

export const findScheduleDesc = (selectedOption) => {
    if (!selectedOption) {
        return "";
    }
    switch (selectedOption.toUpperCase()) {
        case "DAY":
            return i18nUtils.get("scheduled.transaction.day");
        case "WEEK":
            return i18nUtils.get("scheduled.transaction.week");
        case "MONTH":
            return i18nUtils.get("scheduled.transaction.month");
        case "YEAR":
            return i18nUtils.get("scheduled.transaction.year");
        case "FUTURE":
            return i18nUtils.get("scheduled.transaction.future");
        default:
            return "";
    }
};

export const listRecurrencies = () => [
    {
        value: TODAY,
        label: i18nUtils.get(`scheduler.${TODAY.toLowerCase()}`),
    },
    {
        value: ONCE,
        label: i18nUtils.get(`scheduler.${ONCE.toLowerCase()}`),
    },
    {
        value: DAY,
        label: i18nUtils.get(`scheduler.${DAY.toLowerCase()}`),
    },
    {
        value: WEEK,
        label: i18nUtils.get(`scheduler.${WEEK.toLowerCase()}`),
    },
    {
        value: MONTH,
        label: i18nUtils.get(`scheduler.${MONTH.toLowerCase()}`),
    },
    {
        value: YEAR,
        label: i18nUtils.get(`scheduler.${YEAR.toLowerCase()}`),
    },
    // {
    //     value: CUSTOM,
    //     label: i18nUtils.get(`scheduler.${CUSTOM.toLowerCase()}`),
    // },
];

export const listEvery = () => [
    {
        value: DAY,
        label: i18nUtils.get(`scheduler.${DAY.toLowerCase()}s`),
    },
    {
        value: WEEK,
        label: i18nUtils.get(`scheduler.${WEEK.toLowerCase()}s`),
    },
    {
        value: MONTH,
        label: i18nUtils.get(`scheduler.${MONTH.toLowerCase()}s`),
    },
    {
        value: YEAR,
        label: i18nUtils.get(`scheduler.${YEAR.toLowerCase()}s`),
    },
];

export const getOccurrenceWithWeekOfMonth = (weekOfMonth) => {
    switch (weekOfMonth) {
        case 1:
            return FIRST;
        case 2:
            return SECOND;
        case 3:
            return THRID;
        case 4:
            return FOURTH;
        default:
            return LAST;
    }
};

/**
 * Convierte valores de fecha del scheduler (API, borrador, ISO string, moment) a {@link Date} para formularios v2.
 *
 * @param {*} raw Valor recibido desde backend o estado persistido
 * @param {Date} [fallbackDate] Fecha por defecto si raw no es parseable (por defecto: fecha actual)
 * @returns {Date}
 */
export function toSchedulerFormDate(raw, fallbackDate) {
    const fallback = fallbackDate instanceof Date && !Number.isNaN(fallbackDate.getTime()) ? fallbackDate : new Date();
    if (raw == null || raw === "") {
        return fallback;
    }
    if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
        return raw;
    }
    if (moment.isMoment(raw)) {
        const d = raw.toDate();
        return Number.isNaN(d.getTime()) ? fallback : d;
    }
    const parsed = moment(raw);
    return parsed.isValid() ? parsed.toDate() : fallback;
}

/**
 * Devuelve una copia del objeto scheduler con campos de fecha en formato {@link Date} nativo.
 *
 * @param {object|null|undefined} scheduler Estado scheduler desde summary/borrador
 * @returns {object|null|undefined}
 */
export function normalizeSchedulerForForm(scheduler) {
    if (scheduler == null || typeof scheduler !== "object") {
        return scheduler;
    }
    const next = { ...scheduler };
    if (next.valueDate != null) {
        next.valueDate = toSchedulerFormDate(next.valueDate);
    }
    if (next.newValueDate != null) {
        next.newValueDate = toSchedulerFormDate(next.newValueDate);
    }
    if (next.program != null && typeof next.program === "object") {
        const program = { ...next.program };
        if (program.startsOn != null) {
            program.startsOn = toSchedulerFormDate(program.startsOn);
        }
        if (program.date != null) {
            program.date = toSchedulerFormDate(program.date);
        }
        next.program = program;
    }
    return next;
}

/**
 * Normaliza el scheduler dentro del summary de transferencias antes de guardarlo en Redux.
 *
 * @param {object|null|undefined} summary Summary parcial o completo
 * @returns {object|null|undefined}
 */
export function normalizeTransferSummaryScheduler(summary) {
    if (!summary || typeof summary !== "object") {
        return summary;
    }
    if (!summary.scheduler) {
        return summary;
    }
    return {
        ...summary,
        scheduler: normalizeSchedulerForForm(summary.scheduler),
    };
}
